export enum BlockToolsGroup {
  InsertBlockElsKey = 'insertBlockEls',
  InsertPrivateSectionKey = 'insertPrivateSection',
  ChangeAlignmentKey = 'changeAlignment',
  Emoji = 'emoji',
}
